export function redemptionOtpChannelsMessage(channels, fallbackMessage) {
  if (!channels || typeof channels !== "object") {
    return fallbackMessage || "OTP has been sent to the customer.";
  }
  const { email, sms } = channels;
  if (email && sms) {
    return "OTP has been sent to the customer's email and SMS.";
  }
  if (sms) {
    return "OTP has been sent via SMS (email could not be delivered).";
  }
  if (email) {
    return "OTP has been sent via email (SMS could not be delivered).";
  }
  return fallbackMessage || "OTP has been sent to the customer.";
}
